// @ts-nocheck
import React, { useState } from "react";
import { Popover, List, ListItem, ListItemText, IconButton, Badge, Typography } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { formatDistanceToNow } from "date-fns";
import { useTranslation } from "react-i18next";

function Notifications(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [unreadCount, setUnreadCount] = useState(undefined);

  const { t } = useTranslation();
  const { siteNotifications } = props.state;

  if (unreadCount === undefined && siteNotifications.length > 0) {
    let checkUnreadCount = siteNotifications.filter((item) => item.read === false);
    setUnreadCount(checkUnreadCount.length);
  }

  const handleOpen = (event) => {
    setUnreadCount(0);
    props.notificationHandler.updateReadNotification();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div id="notifications">
      <IconButton onClick={handleOpen} color="inherit" size="small">
        <Badge badgeContent={unreadCount ? unreadCount : 0} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <List
          sx={{
            width: 300,
            maxHeight: 400,
            overflowY: "auto",
          }}
        >
          {siteNotifications.length === 0 ? (
            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{ color: "gray", textAlign: "center" }}>
                    {t("notifications.empty")}
                  </Typography>
                }
              />
            </ListItem>
          ) : (
            siteNotifications.map((notification) => (
              <ListItem
                key={notification.id}
                sx={{
                  "&:hover": {
                    backgroundColor: "var(--hover-overlay)",
                    cursor: "pointer",
                  },
                  padding: "8px 16px",
                  transition: "background-color 0.3s ease",
                }}
              >
                <ListItemText
                  primary={notification.message}
                  secondary={
                    <Typography variant="body2" sx={{ color: "gray" }}>
                      {formatDistanceToNow(notification.timestamp)} {t("notifications.ago")}
                    </Typography>
                  }
                />
              </ListItem>
            ))
          )}
        </List>
      </Popover>
    </div>
  );
}

export default Notifications;
